module.exports = __webpack_public_path__ + "static/media/mobile-no.26770f36.svg";